import { render, staticRenderFns } from "./Roleplayer.vue?vue&type=template&id=2f6797d2&"
import script from "./Roleplayer.vue?vue&type=script&lang=js&"
export * from "./Roleplayer.vue?vue&type=script&lang=js&"
import style0 from "./Roleplayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports